module.exports = __webpack_public_path__ + "img/categorie-coquillages-famille-boutrais.ef22c688.jpg";